import createTheme from '../../utils/create-theme';
import tokens from './tokens';

const theme = createTheme(tokens);

export default theme;
